<template>
  <div class="d-block">
    <welcome/>
    <services/>
    <!-- <ourTeam/> -->
    <!-- <contacto/> -->
    <footer-container/>
  </div>
</template>

<script>

import Welcome from './Welcome'
import Services from './Services'
import FooterContainer from './FooterContainer'

export default {
  name: 'App',
  components: {
    Welcome,
    Services,
    FooterContainer,
  }
}
</script>

<style>

</style>
